import { mapActions } from "vuex";

export const canEditCompanyMixin = {
  computed: {
    associatedCompanies() {
      return this.$store.getters.companies;
    }
  },

  methods: {
    ...mapActions(["GET_USER_COMPANIES"]),
    userCanEditItems() {
      if (this.isSuperAdmin) {
        return true;
      }
      let min = Math.min(...this.levelsOfAssociatedCompanies());
      return min === 1;
      // if (this.userHasPermissionTo("update")) {
      //   return item.type > min;
      // } else {
      //   return false;
      // }
    },

    levelsOfAssociatedCompanies() {
      let levels = [];
      let userCompanies = [];
      if (this.associatedCompanies.length > 0) {
        userCompanies = this.associatedCompanies;
      } else {
        userCompanies = this.getAssociatedCompanies();
      }
      if (userCompanies) {
        userCompanies.forEach(item => {
          if (!levels.includes(item.type)) {
            levels.push(item.type);
          }
        });
      }
      return levels;
    },

    getAssociatedCompanies() {
      this.GET_USER_COMPANIES()
        .then(resp => {
          return resp;
        })
        .catch(error => console.error(error));
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/canEditCompanyMixin.js